import { LinearProgress, makeStyles } from '@material-ui/core'
import deburr from 'lodash.deburr'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'

import searchIcon from '../../assets/images/search.svg'
import Context from '../../context'
import { maskCNPJ } from '../../helpers/mask'
import { getPartnersUnits } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function QuizList() {
  const classes = useStyles()
  const { setUser } = useContext(Context)
  const { setAboutCurrentPage } = useContext(Context)
  const [data, setData] = useState(null)
  const [finalData, setFinalData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [query, setQuery] = useState('')

  useEffect(() => {
    if (!isAuthenticated) return history.replace('/')

    setUser(getLoggedUser)
    getData()
    setAboutCurrentPage({
      title: 'Atendimento ao cliente'
    })
  }, [])

  useEffect(() => {
    if (!data) return

    let filtered = data.filter(item => new RegExp(deburr(query), 'i').test(deburr(item.query)))
    setFinalData(filtered)
  }, [query])

  async function getData() {
    try {
      setLoading(true)
      let data = await getPartnersUnits()
      let dataQuery = data.map(item => ({
        ...item,
        query: Object.values(item).join(' '),
        cnpj: maskCNPJ(item.cnpj),
        fullAddress: [
          item.address,
          item.number,
          item.complement,
          item.neighborhood,
          item.city,
          item.uf,
          item.zipcode
        ]
          .filter(Boolean)
          .join(' - ')
      }))
      setData(dataQuery)
      setFinalData(dataQuery)
    } catch {
      //
    } finally {
      setLoading(false)
    }
  }

  function handleQueryChange(e) {
    setQuery(e.target.value)
  }

  return (
    <div className={classes.outerContainer}>
      <div className={classes.content}>
        <div className={classes.row}>
          <div className={classes.filters}>
            <div className={classes.actions} />
          </div>
          <input
            className={classes.search}
            value={query}
            onChange={handleQueryChange}
            placeholder="Buscar..."
          />
        </div>
        <table className={classes.table}>
          <colgroup>
            <col className={classes.fitContent} />
            <col className={classes.fitContent} />
            <col />
            <col className={classes.fitContent} />
          </colgroup>
          <thead>
            <tr>
              <td>Nome</td>
              <td>CNPJ</td>
              <td>Endereço</td>
              <td>Data de criação</td>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              finalData?.map(item => (
                <tr key={item.id}>
                  <td>{item.fantasyName}</td>
                  <td>{item.cnpj}</td>
                  <td>{item.fullAddress}</td>
                  <td>{moment(item.createdAt).format('L [às] LT')}</td>
                </tr>
              ))}
          </tbody>
        </table>
        {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
      </div>
    </div>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '40px 45px'
  },
  filters: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 40,
    marginRight: 30,
    padding: '12px 10px 10px',
    borderBottom: '2px solid #30287b'
  },
  search: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: 190,
    height: 40,
    padding: '10px 15px',
    boxSizing: 'border-box',
    fontSize: '12px',
    color: '#30287b',
    background: `url(${searchIcon}) top right / auto 100% content-box no-repeat`,
    border: '2px solid #30287b'
  },
  table: {
    marginTop: '20px',
    border: '2px solid #30287b',
    '& td': {
      border: '2px solid #30287b'
    },
    '& thead': {
      background: '#30287b'
    },
    '& thead td': {
      fontSize: '12px',
      padding: '17px 25px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '13px',
      textTransform: 'uppercase'
    },
    '& tbody td': {
      fontSize: '14px',
      padding: '17px 25px',
      color: '#30287b'
    }
  },
  fitContent: {
    width: 'fit-content'
  }
})

export default QuizList
